export const COLORS = {
  success: '#34bfa3',
  warning: '#ffb822',
  danger: '#f4516c',
  info: '#36a3f7',
  primary: '#5867dd',
  secondary: '#eaeaea',
  brand: '#716aca',
  accent: '#00c5dc',
  focus: '#9816f4',
  metal: '#c4c5d6',
};
